const env_local = 'local';
const env_dev = 'dev';
const env_staging = 'staging';
const env_prod = 'prod';
const SupportedEnvs = [env_local, env_dev, env_staging, env_prod];
const envs = {
    'local': {
        'defaultConfigUrl': 'http://127.0.0.1:8224/_frontend/default.json?ns=quai-md-km-local',
        'configUrl': 'http://127.0.0.1:8224/_frontend/km.json?ns=quai-md-km-local'
    },
    'dev': {
        'defaultConfigUrl': 'https://quai-md-km-dev-default-rtdb.firebaseio.com/_frontend/default.json',
        'configUrl': 'https://quai-md-km-dev-default-rtdb.firebaseio.com/_frontend/km.json'
    },
    'staging': {
        'defaultConfigUrl': 'https://quai-md-km-staging-default-rtdb.firebaseio.com/_frontend/default.json',
        'configUrl': 'https://quai-md-km-staging-default-rtdb.firebaseio.com/_frontend/km.json'
    },
    'prod': {
        'defaultConfigUrl': 'https://quai-md-km-default-rtdb.firebaseio.com/_frontend/default.json',
        'configUrl': 'https://quai-md-km-default-rtdb.firebaseio.com/_frontend/km.json'
    }
};
const domainsToEnv = {
    'localhost:8221': 'local',
    '127.0.0.1:8221': 'local',
    'knowledge-manager.dev.quaimd.com': 'dev',
    'quai-md-km-dev.firebaseapp.com': 'dev',
    'quai-md-km-dev.web.app': 'dev',
    'knowledge-manager.staging.quaimd.com': 'staging',
    'quai-md-km-staging.firebaseapp.com': 'staging',
    'quai-md-km-staging.web.app': 'staging',
    'knowledge-manager.quaimd.com': 'prod',
    'quai-md-km.firebaseapp.com': 'prod',
    'quai-md-km.web.app': 'prod',
};
export const deriveConfig = () => {
    const recognizedEnv = domainsToEnv[window.location.host];
    if (!recognizedEnv)
        throw new Error(`Unrecognized env for domain: ${window.location.host}`);
    return envs[recognizedEnv];
};
